<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, DatePicker },
    data() {
        return {
            title: "Pagos Laborantes",
            items: [
                {
                text: "Laborantes",
                href: "/"
                },
                {
                text: "Pago",
                active: true
                }
            ],
            laborantes_por_pagar:[],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filtro: '',
            laborantes:[],
            eventos:[],
            apagar:[]
        };
    },
    computed:{
        rows() {
            return this.laborantes.length;
        },
        filteredData() {
            // Filtramos los datos en base al campo 'filtro' 
            return this.laborantes.filter((item) => {
                // Aquí puedes personalizar los campos a buscar
                return (
                    item.rut.toLowerCase().includes(this.filtro.toLowerCase()) ||
                    item.name.toLowerCase().includes(this.filtro.toLowerCase())
                );
            });
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.filteredData.slice(start, end)
        },
        totalPages() {
            return Math.ceil(this.filteredData.length / this.perPage);
        },
    },
    methods:{
        obtenerLabotante(element){
            let laborante = this.laborantes.filter((us) => us.id==element);
            if (laborante.length>0) {
                return laborante[0].name;
            }
        },
        obtenerSede(element){
            let laborante = this.laborantes.filter((us) => us.id==element);
            if (laborante.length>0) {
                return laborante[0].sede;
            }
        },
        obtenerEvento(element){
            let evento = this.eventos.filter((us) => us.id==element);
            if (evento.length>0) {
                return evento[0];
            }else{
                let evento={
                    codigo:'',
                    coordinador_evento:'',
                }
                return evento
            }
        },
        msg(title) {
            Swal.fire({
                icon: 'success',
                title: title,
                //text: `Por favor, completa el campo "${campo}".`,
                showConfirmButton: false,
                timer: 1000
            });
        },
        seleccionar(item){
            let formData = new FormData();
            formData.append('pago_id', item.id);
            formData.append('status', item.status);
            axios.post('/api/seleccionar_pago',formData).then(response => {
                this.msg('Guardado')
            });
        },
        formatFecha(fechahora){
            var orden = moment(fechahora).format('DD-MM-YYYY');
            return orden
        },
        format_Valor_variable(val){
            return val? parseInt(val.toString().replace(/[^0-9]/g, ''), 10)? parseInt(val.toString().replace(/[^0-9]/g, ''), 10).toLocaleString("es-CL", { style: "currency", currency: "CLP" }): '$0': '$0';
        },
        pagar(){
            this.laborantes_por_pagar.forEach(element => {
                if (element.status=='1') {
                    this.apagar.push(element);
                }
            });
            let formData = new FormData();
            formData.append('apagar', JSON.stringify(this.apagar));
            axios.post('/api/pagar',formData).then(response => {
                if(response.data.estado){
                    this.laborantes_por_pagar= response.data.laborantes;
                    this.msg('Laborantes Pagados');
                }
            });
        },
        exportToExcelCompleto() {
            // Datos de ejemplo
            axios.get('/api/export_completo').then(response => {
                const data= response.data.array;
                // Crear una hoja de cálculo
                const ws = XLSX.utils.json_to_sheet(data);
                // Crear un libro de Excel
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "Datos");
                // Generar archivo y guardarlo
                const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
                saveAs(blob, "datos.xlsx");
            });
        },
        exportToExcelBancarios() {
            // Datos de ejemplo
            axios.get('/api/export_datos_bancarios').then(response => {
                const data = response.data.array;
                // Crear una hoja de cálculo
                const ws = XLSX.utils.json_to_sheet(data);
                // Crear un libro de Excel
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "Datos");
                // Generar archivo y guardarlo
                const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
                saveAs(blob, "DatosBancarios.xlsx");
            });
        }
    },
    created(){
        axios.get('/api/get_laborantes_por_pagar').then(response => {
            this.laborantes_por_pagar= response.data.laborantes;
        });
        axios.get('/api/get_eventos').then(response => {
            this.eventos= response.data.eventos;
        });
        axios.get('/api/get_laborantes').then(response => {
            this.laborantes= response.data.usuarios;
        });
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body" v-if="laborantes_por_pagar.length>0">
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <b-button variant="primary" @click="exportToExcelCompleto">Exportar excel completo</b-button>
                                <b-button variant="primary" @click="exportToExcelBancarios">Exportar datos bancarios</b-button>
                            </div>
                            <div class="col-md-6 text-right mb-3">
                                <b-button variant="primary" @click="pagar()">Pagar Seleccionados</b-button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Mostrar&nbsp;
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;recibos
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Buscar:
                                        <b-form-input
                                        v-model="filtro"
                                        type="search"
                                        placeholder="Buscar..."
                                        class="form-control form-control-sm ml-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0 mt-3">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th >Seleccionar</th>
                                        <th >Nombre</th>
                                        <th >Sede</th>
                                        <th >Fecha</th>
                                        <th >Hora inicio</th>
                                        <th >Hora fin</th>
                                        <th >Código evento</th>
                                        <th >Coordinador</th>
                                        <th >Valor Bruto</th>
                                        <th >Valor Líquido</th>
                                        <!-- <th >Acción</th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in laborantes_por_pagar" :key="index">
                                        <td>
                                            <b-form-checkbox
                                                :id="'checkbox-'+index"
                                                v-model="item.status"
                                                name="checkbox-1"
                                                value="1"
                                                unchecked-value="0"
                                                >
                                                </b-form-checkbox>
                                        </td>
                                        <td>{{ obtenerLabotante(item.laborante_id) }}</td>
                                        <td>{{ obtenerSede(item.laborante_id) }}</td>
                                        <td>{{ formatFecha(item.fecha) }}</td>
                                        <td>{{ item.hora_inicio }}</td>
                                        <td>{{ item.hora_fin }}</td>
                                        <td>{{ obtenerEvento(item.evento_id).codigo }}</td>
                                        <td>{{ obtenerEvento(item.evento_id).coordinador_evento }}</td>
                                        <td>{{ format_Valor_variable(item.valor_bruto) }} </td>
                                        <td>{{ format_Valor_variable(item.valor_liquido) }}</td>
                                        <!-- <td> </td> -->
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body text-center" v-else>
                        <h4 class="text-primary">No hay laborantes seleccionados para pagar</h4>
                        <b-button variant="primary" href="/web/laborantes/pagos">Revisar listado</b-button>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>